import { useSearchParams, useNavigate } from "react-router-dom";
import { useEmailVerification } from "../hooks/useEmailVerification";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import AuthShell from "../Components/AuthShell";


const VerifyEmail = () => {

    const { verifyEmail } = useEmailVerification()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const [mssg, setmsg] = useState("")

    useEffect(() => {

        const emailToken = searchParams.get("emailToken")
        // const email = searchParams.get("email")
        const handleVerification = async () => {
         
     const response = await verifyEmail(emailToken)
     
     if(!response){
        setmsg(response)
        setTimeout(() =>{
             navigate("/login")
        },2000);

     }else{
        setmsg(response)
        setTimeout(() => {
            navigate("/login")
        }, 2000);
     }

        }
        if (searchParams.size === 0) {
            return navigate("/login")
        }else if(!emailToken){
            return navigate("/login")
        }else{
            handleVerification()
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    return (
        <AuthShell>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Verify Email - Content Flash AI</title>
                <meta name="description" content="Verifying your Content Flash AI email." />
            </Helmet>
            <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full border-2 border-indigo-500/30 border-t-indigo-400 animate-spin" />
                <h2 className="text-xl font-bold text-gray-900">Verifying your email</h2>
                <p className="text-sm text-gray-500 mt-2 min-h-[1.25rem]">{mssg || "Hang tight, this only takes a moment…"}</p>
            </div>
        </AuthShell>
    )

}
export default VerifyEmail;







